/**
 * Generates and downloads a proposal/contract PDF using @react-pdf/renderer.
 *
 * Renders the <ProposalDocumentPdf /> component to a real (vector, selectable
 * text) PDF Blob and triggers a browser download. The same component can be
 * rendered server-side later if a native mobile path ever needs it.
 */
import React from 'react'
import { pdf } from '@react-pdf/renderer'
import { ProposalDocumentPdf, type ProposalDocumentProps } from '../components/ProposalDocumentPdf'

export async function downloadDocumentPdf(
  props: ProposalDocumentProps,
  fileName: string
): Promise<void> {
  const instance = pdf(React.createElement(ProposalDocumentPdf, props))
  const blob = await instance.toBlob()

  const url = URL.createObjectURL(blob)
  try {
    const link = document.createElement('a')
    link.href = url
    link.download = `${fileName}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } finally {
    // Revoke after a tick so the download has a chance to start.
    setTimeout(() => URL.revokeObjectURL(url), 1000)
  }
}
